module.exports = [{
      plugin: require('/tmp/build_0c1dcf59ee1ce05846ff1e9162f1202e/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Lekha Surasani","short_name":"Lekha Surasani","start_url":"/","background_color":"#6b37bf","theme_color":"#6b37bf","display":"standalone","icon":"src/images/icon.png"},
    },{
      plugin: require('/tmp/build_0c1dcf59ee1ce05846ff1e9162f1202e/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/tmp/build_0c1dcf59ee1ce05846ff1e9162f1202e/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
